module.exports = {"610803001":"城关街道","610803002":"怀远街道","610803003":"夏州街道","610803004":"怀仁路街道","610803005":"崇德路街道","610803101":"石湾镇","610803102":"高镇","610803103":"武镇","610803104":"党岔镇","610803105":"响水镇","610803106":"波罗镇","610803107":"殿市镇","610803108":"塔湾镇","610803109":"赵石畔镇","610803110":"魏家楼镇","610803111":"韩岔镇","610803112":"白界镇","610803113":"雷龙湾镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/610803.json
// module id = 2860
// module chunks = 0